import {
  UserTelemetryKeys,
  UserTelemetryValues,
} from './usersTelemetryConstants';

export interface ITelemetryEvent {
  name: string;
  properties?: Map<UserTelemetryKeys, UserTelemetryValues>;
  ErrorReason?: string;
}

export type EventFlow = Record<string, ITelemetryEvent>;

export const usersTelemetry: Record<string, EventFlow> = {
  invite: {
    start: { name: 'Invite Users: Started' },
    addUserDetails: {
      name: 'Invite Users: Added User Details',
      properties: new Map([[UserTelemetryKeys.NoOfUsersAdded, 1]]),
    },
    assignGroup: {
      name: 'Invite Users: Assigned Groups',
      properties: new Map([[UserTelemetryKeys.NoOfGroupsAssigned, 0]]),
    },
    newGroupCreated: { name: 'Invite Users: New Group Created' },
    rolesAssignedAndInvitedUsers: {
      name: 'Invite Users: Roles Assigned And Invited Users',
      properties: new Map([[UserTelemetryKeys.NoOfRolesAssigned, 0]]),
    },
  },
  import: {
    start: { name: 'Import Users: Started' },
    addUserDetails: { name: 'Import Users: User Details Added' },
    assignGroup: {
      name: 'Import Users: Assigned Groups',
      properties: new Map([[UserTelemetryKeys.NoOfGroupsAssigned, 0]]),
    },
    newGroupCreated: { name: 'Import Users: New Group Created' },
    rolesAssignedAndInvitedUsers: {
      name: 'Import Users: Roles Assigned And Invited Users',
      properties: new Map([[UserTelemetryKeys.NoOfRolesAssigned, 0]]),
    },
  },
  userRowActionMenu: {
    disableAccount: { name: 'Users: Account Disabled' },
    accountRestored: { name: 'Users: Account Restored' },
    passwordReset: { name: 'Users: Password Reset' },
    mfaReset: { name: 'Users: MFA Reset' },
    deletedUser: { name: 'Users: Deleted User' },
  },
  editUser: {
    editUserName: { name: 'Edit Users: Edited User Name' },
    roleRemoved: { name: 'Edit Users: Role Removed For The User' },
    roleAssigned: {
      name: 'Edit Users: Role Assigned For The User',
      properties: new Map([[UserTelemetryKeys.NoOfRolesAssigned, 1]]),
    },
    groupRemoved: { name: 'Edit Users: Group Removed' },
    groupAssigned: {
      name: 'Edit Users: Group Assigned For The User',
      properties: new Map([[UserTelemetryKeys.NoOfGroupsAssigned, 0]]),
    },
  },
};

export const usersErrorTelemetry: Record<string, EventFlow> = {
  invite: {
    rolesAssignedAndInvitedUsersError: { name: 'Invite Users: Failed' },
    failedToCreateGroup: {
      name: 'Invite Users: Failed To Create Group',
      properties: new Map([[UserTelemetryKeys.ErrorReason, 0]]),
    },
  },
  import: {
    rolesAssignedAndInvitedUsersError: { name: 'Import Users: Failed' },
    failedToCreateGroup: {
      name: 'Import Users: Failed To Create Group',
      properties: new Map([[UserTelemetryKeys.ErrorReason, 0]]),
    },
  },
  userRowActionMenu: {
    passwordResetError: { name: 'Users: Failed To Reset Password' },
    disableAccountError: { name: 'Users: Failed To Disable' },
    mfaResetError: { name: 'Users: Failed To Reset MFA' },
    deletedUserError: { name: 'Users: Failed To Delete User' },
    viewUserDetailsError: { name: 'Users: Error Viewing User Details' },
    removeRoleError: { name: 'Edit Users: Failed To Remove Role For User' },
    assignRoleError: { name: 'Edit Users: Failed To Assign Role To User' },
    removeGroupError: { name: 'Edit Users: Failed To Remove Group' },
    assignGroupError: { name: 'Edit Users: Failed To Assign Group' },
  },
  editUser: {
    editUserNameError: { name: 'Edit Users: Failed To Update Name' },
  },
  EllipticMenuAction: {
    enableUserError: { name: 'Users: Failed To Restore Account' },
  },
};
